// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d85cfadc","453":"127be8e2","455":"6aba7537"}[chunkId] + ".chunk.js";
};